var map = {
	"./goldcoin/task-detail-step-1.jpg": 55597,
	"./memetown/task-detail-step-1.jpg": 67223,
	"./reflection/task-detail-step-1.jpg": 33145,
	"./tapcoin/task-detail-step-1.jpg": 82173
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45912;